import { render, staticRenderFns } from "./editArticleTag.vue?vue&type=template&id=377be97a&scoped=true&"
import script from "./editArticleTag.vue?vue&type=script&lang=ts&"
export * from "./editArticleTag.vue?vue&type=script&lang=ts&"
import style0 from "./editArticleTag.vue?vue&type=style&index=0&id=377be97a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377be97a",
  null
  
)

export default component.exports